import { render, staticRenderFns } from "./EditTaskForm.vue?vue&type=template&id=46d86082&scoped=true"
import script from "./EditTaskForm.vue?vue&type=script&lang=js"
export * from "./EditTaskForm.vue?vue&type=script&lang=js"
import style0 from "./EditTaskForm.vue?vue&type=style&index=0&id=46d86082&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d86082",
  null
  
)

export default component.exports